export type DeviceOS =
  | "ios"
  | "android"
  | "mac"
  | "windows"
  | "linux"
  | "other";

export function getDeviceFromNavigator(): DeviceOS {
  if (typeof navigator === "undefined") return "other";

  const ua = (navigator.userAgent || "").toLowerCase();
  const platformCH = (
    navigator as any
  ).userAgentData?.platform?.toLowerCase?.();
  const platform = (navigator.platform || "").toLowerCase();
  const maxTouchPoints =
    typeof (navigator as any).maxTouchPoints === "number"
      ? (navigator as any).maxTouchPoints
      : 0;

  if (platformCH?.includes("android") || ua.includes("android"))
    return "android";

  const isIOSUA = /(iphone|ipad|ipod)/.test(ua);
  const isIPadOSMasquerade = ua.includes("macintosh") && maxTouchPoints > 1;
  if (isIOSUA || isIPadOSMasquerade) return "ios";

  const isMac =
    platformCH?.includes("mac") ||
    platform.includes("mac") ||
    ua.includes("macintosh") ||
    ua.includes("mac os x");
  if (isMac) return "mac";

  if (
    platformCH?.includes("windows") ||
    platform.includes("win") ||
    ua.includes("windows")
  )
    return "windows";

  if (
    platformCH?.includes("linux") ||
    platform.includes("linux") ||
    ua.includes("linux")
  )
    return "linux";

  return "other";
}

export function isSafari(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent.toLowerCase();

  const isIOS =
    /(iphone|ipad|ipod)/.test(ua) ||
    (ua.includes("macintosh") && (navigator as any).maxTouchPoints > 1);
  const looksLikeSafari = ua.includes("safari");
  const isChromeiOS = ua.includes("crios"); //
  const isFirefoxiOS = ua.includes("fxios");
  const isEdgeiOS = ua.includes("edgios");

  if (!looksLikeSafari) return false;
  if (isChromeiOS || isFirefoxiOS || isEdgeiOS) return false;

  return isIOS ? true : ua.includes("version/") && looksLikeSafari;
}
